import {debounce} from "lodash";

export function Debounce(milliseconds: number = 0, options = {}): MethodDecorator {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        const map = new WeakMap();
        
        const originalMethod = descriptor.value;
        descriptor.value = function (...params) {
            let debounced = map.get(this);
            if (!debounced) {
                debounced = debounce(originalMethod, milliseconds, options).bind(this);
                map.set(this, debounced);
            }
            debounced(...params);
        };
        
        
        return descriptor;
    }
}
